module.exports = __webpack_public_path__ + "static/media/cc-2.228a6a4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cc-2.png
// module id = 101
// module chunks = 0